import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationRefreshTick } from "../context/NavigationRefreshContext";

/**
 * Ejecuta `callback` al montar la pantalla y cada vez que el usuario entra en la ruta
 * (cambio de pathname/search/key o tras guardar un formulario con markListsForRefresh).
 */
export function useReloadOnRouteEnter(callback, extraDeps = []) {
  const location = useLocation();
  const navTick = useNavigationRefreshTick();
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    cbRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, location.key, navTick, ...extraDeps]);
}
